import { SuggestedChecklistsByDocumentType } from '@dc-shared-web/hooks/api/office/types'
import { AxiosInstance } from 'axios'

export const fetchOfficeSuggestedChecklists = async (
  apiClient: AxiosInstance,
  params: {
    officeUUID: string
  }
) => {
  const { data } = await apiClient.get<SuggestedChecklistsByDocumentType[]>(
    `/api/office/${params.officeUUID}/suggested-checklists`
  )

  return data
}
